import { lazyLoad } from 'utils/loadable';

export const lazyOrderPage = lazyLoad(
  () =>
    import(
      /*  webpackChunkName: 'OrderPage', webpackPrefetch: true */ './index'
    ),
  module => module.default,
);

export const orderRoutes = [
  {
    component: lazyOrderPage,
    path: '/customer-assist/orders',
    title: 'Orders',
    needsAuth: true,
  },
];
